export const BUSINESS = {
  name: "El Japonais",
  tagline: "Fine Grooming for Every Community",
  city: "Calgary",
  address: "15 Sugarsnap Ave SE, Calgary, AB T3S 0K8",
  phone: "(514) 292-8780",
  whatsapp: "15142928780",
  logo: "/logo.jpg",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1773904215697-e6c21fc27ac2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBkYXJrJTIwYmFyYmVyc2hvcCUyMGludGVyaW9yfGVufDB8fHx8MTc4NjUwNzg0MXww&ixlib=rb-4.1.0&q=85",
  cut1: "https://images.unsplash.com/photo-1567894340315-735d7c361db0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxibGFjayUyMG1hbiUyMGZyZXNoJTIwZmFkZSUyMGhhaXJjdXQlMjBiYXJiZXJ8ZW58MHx8fHwxNzg2NTA3OTUzfDA&ixlib=rb-4.1.0&q=85",
  cut2: "https://images.unsplash.com/photo-1512864084360-7c0c4d0a0845?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxibGFjayUyMG1hbiUyMGZyZXNoJTIwZmFkZSUyMGhhaXJjdXQlMjBiYXJiZXJ8ZW58MHx8fHwxNzg2NTA3OTUzfDA&ixlib=rb-4.1.0&q=85",
  cut3: "https://images.unsplash.com/photo-1648389824823-483ec5ca228a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxibGFjayUyMG1hbiUyMGJhcmJlcnxlbnwwfHx8fDE3ODY1MDc4NDZ8MA&ixlib=rb-4.1.0&q=85",
  cut4: "https://images.unsplash.com/photo-1604355240616-5e907f42b431?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxibGFjayUyMG1hbiUyMGZyZXNoJTIwZmFkZSUyMGhhaXJjdXQlMjBiYXJiZXJ8ZW58MHx8fHwxNzg2NTA3OTUzfDA&ixlib=rb-4.1.0&q=85",
  braids: "https://images.unsplash.com/photo-1594254773847-9fce26e950bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxib3glMjBicmFpZHMlMjBkcmVhZGxvY2tzJTIwYmxhY2slMjBoYWlyc3R5bGV8ZW58MHx8fHwxNzg2NTA3OTUzfDA&ixlib=rb-4.1.0&q=85",
  braids2: "https://images.unsplash.com/photo-1572955304332-bf714bd49add?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxib3glMjBicmFpZHMlMjBkcmVhZGxvY2tzJTIwYmxhY2slMjBoYWlyc3R5bGV8ZW58MHx8fHwxNzg2NTA3OTUzfDA&ixlib=rb-4.1.0&q=85",
  dreadlocks: "https://images.unsplash.com/photo-1709672262859-68cb9b39ae4f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxib3glMjBicmFpZHMlMjBkcmVhZGxvY2tzJTIwYmxhY2slMjBoYWlyc3R5bGV8ZW58MHx8fHwxNzg2NTA3OTUzfDA&ixlib=rb-4.1.0&q=85",
  accessories: "https://images.unsplash.com/photo-1613641087813-7ceb7e917c8d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxnb2xkJTIwc2Npc3NvcnN8ZW58MHx8fHwxNzg2NTA3ODQ3fDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  { id: "haircuts", name: "Haircuts", status: "available", price: "from $30",
    blurb: "Precision fades, tapers, line-ups and sculpting tailored to every hair type and texture.",
    image: IMAGES.cut1 },
  { id: "braids", name: "Braids", status: "soon",
    blurb: "Box braids, cornrows and protective styles. Launching soon.", image: IMAGES.braids },
  { id: "coloring", name: "Coloring", status: "soon",
    blurb: "Bold tones and subtle blends for a signature statement.", image: IMAGES.cut4 },
  { id: "dreadlocks", name: "Dreadlocks", status: "soon",
    blurb: "Starter locs, retwists and maintenance done right.", image: IMAGES.dreadlocks },
  { id: "accessories", name: "Accessories", status: "shop",
    blurb: "Curated grooming tools and care products — shop now.", image: IMAGES.accessories },
];

export const BOOKABLE_SERVICES = SERVICES.filter((s) => s.status === "available").map((s) => s.name);

export const MANIFESTO = [
  { no: "01", title: "The Craft", body: "Every cut begins with the eye. We read the head shape, the growth pattern, the texture — then sculpt with intention. No two heads are the same, and neither are our cuts." },
  { no: "02", title: "The Culture", body: "Rooted in Black and African hair craft, and open to every community. Whatever your texture, style or background, you're understood, celebrated, and given the mastery you deserve." },
  { no: "03", title: "The Experience", body: "Warm lighting, sharp lines, real conversation. A grooming ritual in the heart of Calgary that leaves you looking and feeling elevated." },
];

export const buildWhatsAppLink = (appt) => {
  const text = `New booking request — El Japonais%0A%0AName: ${appt.name}%0APhone: ${appt.phone}%0AService: ${appt.service}%0ADate: ${appt.date}%0ATime: ${appt.time}${appt.notes ? `%0ANotes: ${appt.notes}` : ""}`;
  return `https://wa.me/${BUSINESS.whatsapp}?text=${text}`;
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const productImage = (p) => {
  if (p.image_url) return p.image_url;
  if (p.image_path) return `${API}/files/${p.image_path}`;
  return IMAGES.accessories;
};

export const buildOrderWhatsAppLink = (items) => {
  const total = items.reduce((s, i) => s + i.price * i.qty, 0);
  const lines = items.map((i) => `• ${i.name} x${i.qty} — $${(i.price * i.qty).toFixed(2)}`).join("%0A");
  const text = `New order — El Japonais Accessories%0A%0A${lines}%0A%0ATotal: $${total.toFixed(2)}%0A%0AI'd like to arrange payment & pickup.`;
  return `https://wa.me/${BUSINESS.whatsapp}?text=${text}`;
};
